import { applyProductNameNormalize } from "./engine.js";
import { cloneDefaultProductNameNormalizeConfig, DEFAULT_PRODUCT_NAME_NORMALIZE_CONFIG } from "./defaultConfig.js";

let runtimeConfig = cloneDefaultProductNameNormalizeConfig();

export function getProductNameNormalizeRuntimeConfig() {
    return runtimeConfig;
}

/** Повна заміна конфігурації в пам'яті (після завантаження з API / БД). */
export function setProductNameNormalizeRuntimeConfig(config) {
    if (!config || typeof config !== "object") {
        runtimeConfig = cloneDefaultProductNameNormalizeConfig();
        return;
    }
    runtimeConfig = JSON.parse(JSON.stringify(config));
}

export function resetProductNameNormalizeRuntimeToDefault() {
    runtimeConfig = cloneDefaultProductNameNormalizeConfig();
}

export { DEFAULT_PRODUCT_NAME_NORMALIZE_CONFIG, cloneDefaultProductNameNormalizeConfig };

export function normalizeProductName(name) {
    return applyProductNameNormalize(name, runtimeConfig);
}
